import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = { class: "row justify-between" };
const _hoisted_3 = { class: "row items-center" };
const _hoisted_4 = { class: "text-h4 text-bold text-green-7" };
const _hoisted_5 = { class: "q-pl-sm" };
const _hoisted_6 = { class: "text-h6 text-right text-weight-bold" };
const _hoisted_7 = { class: "q-pa-md" };
const _hoisted_8 = { class: "text-right q-mb-sm" };
const _hoisted_9 = { class: "q-pa-md" };
const _hoisted_10 = { class: "q-mb-lg entry-check-table" };
const _hoisted_11 = { class: "multiline" };
const _hoisted_12 = { class: "q-mb-lg entry-check-table" };
const _hoisted_13 = { colspan: "2" };
const _hoisted_14 = { colspan: "2" };
const _hoisted_15 = { colspan: "2" };
const _hoisted_16 = { class: "email-td" };
const _hoisted_17 = { colspan: "2" };
const _hoisted_18 = { class: "q-mb-lg entry-check-table" };
const _hoisted_19 = {
    key: 0,
    class: "text-right q-mb-lg"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = ["onClick"];
const _hoisted_22 = { class: "q-mb-lg entry-check-table" };
const _hoisted_23 = { class: "multiline" };
const _hoisted_24 = { class: "multiline" };
const _hoisted_25 = { class: "multiline" };
const _hoisted_26 = { class: "dlg-content" };
const _hoisted_27 = { class: "text-bold" };
const _hoisted_28 = { class: "row items-center" };
const _hoisted_29 = { class: "row col-6 items-center" };
const _hoisted_30 = { class: "q-pl-md" };
const _hoisted_31 = { class: "row col-6 items-center" };
const _hoisted_32 = { class: "q-pl-md" };
const _hoisted_33 = { class: "dlg-actions" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_breadcrumb_list = _resolveComponent("breadcrumb-list");
    const _component_mypage_badge = _resolveComponent("mypage-badge");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_badge = _resolveComponent("q-badge");
    const _component_q_td = _resolveComponent("q-td");
    const _component_q_tr = _resolveComponent("q-tr");
    const _component_q_table = _resolveComponent("q-table");
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_dialog = _resolveComponent("q-dialog");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "col column no-wrap" }, {
        default: _withCtx(() => [
            _createVNode(_component_breadcrumb_list, {
                breadCrumbs: [
                    { itemId: _ctx.top },
                    { itemId: _ctx.nyukyoshaList },
                    { itemId: _ctx.nyukyoshaDetail }
                ]
            }, null, 8, ["breadCrumbs"]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.pageName), 1),
                                        _createElementVNode("div", _hoisted_5, [
                                            _createVNode(_component_mypage_badge, {
                                                kbn: _ctx.NyukyoKbn,
                                                id: _ctx.nyukyoData.taikyoStatus
                                            }, null, 8, ["kbn", "id"])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_6, " 入居契約No.：" + _toDisplayString(_ctx.nyukyoData.nyukyokeiyakuNo), 1)
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        (_ctx.isHeadquarters)
                                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                                key: 0,
                                                label: "ログイン",
                                                icon: "login",
                                                color: "green-7",
                                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.visibleLoginComfirmDialog = true))
                                            }))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "table-caption" }, "物件情報", -1)),
                                        _createElementVNode("table", _hoisted_10, [
                                            _createElementVNode("tbody", null, [
                                                _createElementVNode("tr", null, [
                                                    _cache[4] || (_cache[4] = _createElementVNode("th", null, "住所", -1)),
                                                    _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.nyukyoData.addressAll), 1)
                                                ])
                                            ])
                                        ]),
                                        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "table-caption" }, "お客様情報", -1)),
                                        _createElementVNode("table", _hoisted_12, [
                                            _createElementVNode("tbody", null, [
                                                _createElementVNode("tr", null, [
                                                    _cache[5] || (_cache[5] = _createElementVNode("th", null, "契約者名", -1)),
                                                    _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.nyukyoData.keiyakusha), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                    _cache[6] || (_cache[6] = _createElementVNode("th", null, "入居者名", -1)),
                                                    _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.nyukyoData.nyukyosha), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                    _cache[7] || (_cache[7] = _createElementVNode("th", null, "連絡先電話番号", -1)),
                                                    _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.nyukyoData.telephoneNumber), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                    _cache[8] || (_cache[8] = _createElementVNode("th", null, "メールアドレス", -1)),
                                                    _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.nyukyoData.email), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                    _cache[9] || (_cache[9] = _createElementVNode("th", null, "契約日", -1)),
                                                    _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.nyukyoData.keiyakuYmd), 1)
                                                ])
                                            ])
                                        ]),
                                        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "table-caption" }, "担当店舗", -1)),
                                        _createElementVNode("table", _hoisted_18, [
                                            _createElementVNode("tbody", null, [
                                                _createElementVNode("tr", null, [
                                                    _cache[10] || (_cache[10] = _createElementVNode("th", null, "店舗名", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(_ctx.nyukyoData.shopName), 1)
                                                ])
                                            ])
                                        ])
                                    ]),
                                    (_ctx.nyukyoData.showSelfCertificateCheckButton)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                            _createVNode(_component_q_btn, {
                                                label: "変更確認書内容確認",
                                                color: "green-7",
                                                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.onClickShinjosho()))
                                            }, {
                                                default: _withCtx(() => [
                                                    (!_ctx.nyukyoData.isSelfCertificateCheck)
                                                        ? (_openBlock(), _createBlock(_component_q_badge, {
                                                            key: 0,
                                                            style: { "min-width": "20px", "min-height": "20px", "justify-content": "center", "font-size": "15px" },
                                                            floating: "",
                                                            rounded: "",
                                                            name: "error",
                                                            size: "lg",
                                                            color: "red",
                                                            label: "!"
                                                        }))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                            })
                                        ]))
                                        : _createCommentVNode("", true),
                                    _cache[14] || (_cache[14] = _createElementVNode("hr", { class: "q-mb-lg" }, null, -1))
                                ])
                            ]),
                            _: 1
                        }),
                        (_ctx.nyukyoData.shomeiList.length > 0 && _ctx.nyukyoData.userKb === 0)
                            ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "table-caption" }, "証明書発行状況", -1)),
                                        _createVNode(_component_q_table, {
                                            rows: _ctx.nyukyoData.shomeiList,
                                            columns: _ctx.shomeiColumns,
                                            class: "no-hover",
                                            "hide-bottom": "",
                                            "row-key": "rowIndex",
                                            "no-data-label": "データが見つかりませんでした。",
                                            "rows-per-page-options": [99]
                                        }, {
                                            body: _withCtx((props) => [
                                                _createVNode(_component_q_tr, { props: props }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_q_td, { class: "text-left" }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(props.row.shomeiNo), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1024),
                                                        _createVNode(_component_q_td, { class: "text-left" }, {
                                                            default: _withCtx(() => [
                                                                _createElementVNode("a", {
                                                                    href: "#",
                                                                    onClick: _withModifiers(($event) => (_ctx.onClickShomei(props.row.shomeiNo)), ["prevent"])
                                                                }, _toDisplayString(props.row.shomeiKbName), 9, _hoisted_20)
                                                            ]),
                                                            _: 2
                                                        }, 1024),
                                                        _createVNode(_component_q_td, { class: "text-center" }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(props.row.shinseiYmd), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1024),
                                                        _createVNode(_component_q_td, { class: "text-left" }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(props.row.shomeiStatusName), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1024),
                                                        _createVNode(_component_q_td, { class: "text-left" }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(props.row.shomeiBikou), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1024)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["props"])
                                            ]),
                                            _: 1
                                        }, 8, ["rows", "columns"])
                                    ])
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        (_ctx.nyukyoData.informationList.length > 0)
                            ? (_openBlock(), _createBlock(_component_q_card_section, { key: 1 }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "table-caption" }, "お知らせ情報", -1)),
                                        _createVNode(_component_q_table, {
                                            rows: _ctx.nyukyoData.informationList,
                                            columns: _ctx.informationColumns,
                                            class: "no-hover",
                                            "hide-bottom": "",
                                            "row-key": "rowIndex",
                                            "no-data-label": "データが見つかりませんでした。",
                                            "rows-per-page-options": [5]
                                        }, {
                                            body: _withCtx((props) => [
                                                _createVNode(_component_q_tr, { props: props }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_q_td, { class: "text-center" }, {
                                                            default: _withCtx(() => [
                                                                (props.row.weight)
                                                                    ? (_openBlock(), _createBlock(_component_q_icon, {
                                                                        key: 0,
                                                                        name: "info",
                                                                        size: "md",
                                                                        color: "red"
                                                                    }))
                                                                    : _createCommentVNode("", true)
                                                            ]),
                                                            _: 2
                                                        }, 1024),
                                                        _createVNode(_component_q_td, { class: "text-center" }, {
                                                            default: _withCtx(() => [
                                                                (props.row.isReaded)
                                                                    ? (_openBlock(), _createBlock(_component_q_icon, {
                                                                        key: 0,
                                                                        size: "md",
                                                                        name: "visibility"
                                                                    }))
                                                                    : _createCommentVNode("", true)
                                                            ]),
                                                            _: 2
                                                        }, 1024),
                                                        _createVNode(_component_q_td, { class: "text-center" }, {
                                                            default: _withCtx(() => [
                                                                (props.row.responseContent !== 0)
                                                                    ? (_openBlock(), _createBlock(_component_mypage_badge, {
                                                                        key: 0,
                                                                        kbn: _ctx.ResponsesContentKbn,
                                                                        id: props.row.responseContent
                                                                    }, null, 8, ["kbn", "id"]))
                                                                    : _createCommentVNode("", true)
                                                            ]),
                                                            _: 2
                                                        }, 1024),
                                                        _createVNode(_component_q_td, { class: "text-center" }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(props.row.startAt), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1024),
                                                        _createVNode(_component_q_td, { class: "text-center" }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(props.row.endAt), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1024),
                                                        _createVNode(_component_q_td, { class: "text-left" }, {
                                                            default: _withCtx(() => [
                                                                _createElementVNode("a", {
                                                                    href: "#",
                                                                    onClick: _withModifiers(($event) => (_ctx.onClickInformation(props.row.informationNo)), ["prevent"])
                                                                }, _toDisplayString(props.row.subject), 9, _hoisted_21)
                                                            ]),
                                                            _: 2
                                                        }, 1024)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["props"])
                                            ]),
                                            _: 1
                                        }, 8, ["rows", "columns"])
                                    ])
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "table-caption" }, "ログイン情報", -1)),
                                _createElementVNode("table", _hoisted_22, [
                                    _createElementVNode("tbody", null, [
                                        _createElementVNode("tr", null, [
                                            _cache[17] || (_cache[17] = _createElementVNode("th", null, "最終ログイン日時", -1)),
                                            _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.nyukyoData.updateDate), 1),
                                            _cache[18] || (_cache[18] = _createElementVNode("th", null, "アカウントロック日時", -1)),
                                            _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.nyukyoData.lockDate), 1),
                                            _cache[19] || (_cache[19] = _createElementVNode("th", null, "ログイン失敗数", -1)),
                                            _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.nyukyoData.failuresCount), 1)
                                        ])
                                    ])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    class: "btn-route col-8 col-md-4",
                                    label: "一覧に戻る",
                                    color: "grey-8",
                                    icon: "navigate_before",
                                    onClick: _ctx.toListPage
                                }, null, 8, ["onClick"])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ]),
            _createVNode(_component_q_dialog, {
                class: "mypage-dialog dlg--no-title dlg--open",
                "transition-duration": "200",
                "transition-hide": "fade",
                modelValue: _ctx.visibleLoginComfirmDialog,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.visibleLoginComfirmDialog) = $event)),
                persistent: ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_q_card, { class: "dlg-wrapper" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_26, [
                                _createTextVNode(_toDisplayString(_ctx.PI0009) + " ", 1),
                                _createVNode(_component_q_card, { class: "q-my-md q-pa-sm" }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.nyukyoData.bukkenNameWithRoom), 1),
                                        _createElementVNode("div", _hoisted_28, [
                                            _createElementVNode("div", _hoisted_29, [
                                                _createVNode(_component_q_icon, {
                                                    size: "1.5em",
                                                    name: "perm_identity"
                                                }),
                                                _createElementVNode("div", null, [
                                                    _cache[21] || (_cache[21] = _createElementVNode("div", null, "契約者", -1)),
                                                    _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.nyukyoData.keiyakusha), 1)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_31, [
                                                _createVNode(_component_q_icon, {
                                                    size: "1.5em",
                                                    name: "perm_identity"
                                                }),
                                                _createElementVNode("div", null, [
                                                    _cache[22] || (_cache[22] = _createElementVNode("div", null, "入居者", -1)),
                                                    _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.nyukyoData.nyukyosha), 1)
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _: 1
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.PI0010), 1)
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                                _createVNode(_component_q_btn, {
                                    class: "dlg-action cancel-action",
                                    flat: "",
                                    label: "キャンセル",
                                    onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.visibleLoginComfirmDialog = false))
                                }),
                                _createVNode(_component_q_btn, {
                                    class: "dlg-action ok-action",
                                    flat: "",
                                    label: "OK",
                                    onClick: _ctx.onClickLoginConfirmDialog
                                }, null, 8, ["onClick"])
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["modelValue"])
        ]),
        _: 1
    }));
}
